module.exports = __webpack_public_path__ + "static/media/search.4e2485af.png";